import React, { useState, useEffect } from "react";
import "./compare.css";
import axios from "axios";
import { apiurl } from "../../Constants";
import { addToCart } from "../../features/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeFromCompare } from "../../features/compareSlicetwo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FadeLoader } from "react-spinners";
import { Link } from "react-router-dom";
import Nocompareimage from "../../assets/images/no_compare_products.png";
import { initializeCompareProductIds } from "../../features/compareSlicetwo";
function Compare() {
  const user_id = localStorage.getItem("userId");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(initializeCompareProductIds()); // Initialize state from cookies
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const compareProductIds = useSelector(
    (state) => state.compare.compareProductIds || []
  );

  const [data, setComparisonData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [loading, setLoading] = useState(false);

  const [loadingItems, setLoadingItems] = useState({});

  const { items: cartitems } = useSelector((state) => state.cartitems);

  const IsinCart = (product_id) => {
    return (
      cartitems && cartitems.some((cartdata) => cartdata.id === product_id)
    );
  };

  useEffect(() => {
    if (compareProductIds?.length > 0) {
      const fetchComparisonData = async () => {
        setIsLoading(true); // Show loader when fetching starts
        try {
          const response = await axios.post(apiurl + "product_comparison", {
            product_ids: compareProductIds.join(","),
          });
          setComparisonData(response.data.data); // Set the comparison data
        } catch (error) {
          console.log("Error fetching comparison data:", error);
        } finally {
          setIsLoading(false); // Hide loader when fetching is complete
        }
      };
      fetchComparisonData();
    } else {
      setIsLoading(false); // Hide loader if no product IDs
    }
  }, [compareProductIds]);

  const handleAddToCart = (item) => {
    if (!user_id) {
      navigate("/login");
    }

    setLoadingItems((prev) => ({ ...prev, [item.id]: true }));

    dispatch(addToCart({ user_id, product_id: item.id, quantity: 1 }))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleRemoveFromCompare = (productId) => {
    dispatch(removeFromCompare(productId)); // Dispatch the remove action
  };

  return (
    <>
      {compareProductIds && compareProductIds.length > 0 ? (
        <section className="pt-40 pb-40 compare_Section_one">
          <div className="container">
            {isLoading ? (
              <div
                className="col-12 d-flex"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "30px",
                }}
              >
                <FadeLoader size={100} />
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table">
                  <tbody>
                    {/* Displaying the number of products being compared */}
                    <tr>
                      <td></td>
                      {data.map((item, index) => {
                        return (
                          <td key={index} className="text-end">
                            {}
                            <button
                              className="remove-btn btn btn-secondary"
                              onClick={() => handleRemoveFromCompare(item.id)}
                            >
                              <FontAwesomeIcon icon={faXmark} />
                            </button>
                          </td>
                        );
                      })}
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <h1
                            className="text-start"
                            style={{
                              color: "#76a70e",
                              fontWeight: "700",
                              fontSize: "60px",
                            }}
                          >
                            {data && data.length > 0 ? data.length : 0}
                          </h1>
                          <p>Comparing Products</p>
                        </div>
                      </td>

                      {data.map((item, index) => (
                        <td key={index} className="upper_mainbox">
                          <Link
                            to={`/product-details/${item.id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <img src={item.product_image[0]} alt="img" />
                          </Link>
                        </td>
                      ))}
                    </tr>

                    <tr>
                      <td>Product Name</td>

                      {data.map((item, index) => (
                        <td key={index} className="upper_mainbox">
                          <Link
                            to={`/product-details/${item.id}`}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <h6 className="text-center">{item.product_name}</h6>
                          </Link>
                        </td>
                      ))}
                    </tr>

                    <tr>
                      <td>Actual Price</td>
                      {data.map((item, index) => (
                        <td key={index} style={{ minWidth: "250px" }}>
                          {item.actual_price}
                        </td>
                      ))}
                    </tr>

                    <tr>
                      <td>Discount Price</td>
                      {data.map((item, index) => (
                        <td key={index}>{item.discount_price}</td>
                      ))}
                    </tr>

                    {/* <tr>
                      <td>Description</td>
                      {data.map((item, index) => (
                        <td key={index}>{item.description}</td>
                      ))}
                    </tr>

                    <tr>
                      <td>Short Description</td>
                      {data.map((item, index) => (
                        <td key={index}>{item.short_description}</td>
                      ))}
                    </tr> */}

                    {[
                      ...new Set(
                        data.flatMap((item) =>
                          Array.isArray(item.term)
                            ? item.term.map((t) => t.attribute_name)
                            : []
                        )
                      ),
                    ].map((attribute, idx) => (
                      <tr key={idx}>
                        <td style={{ textTransform: "capitalize" }}>
                          {" "}
                          {attribute.replace(/_/g, " ")}
                        </td>
                        {data.map((item, index) => {
                          const termData =
                            Array.isArray(item.term) &&
                            item.term.find(
                              (t) => t.attribute_name === attribute
                            );
                          return (
                            <td key={index}>
                              {termData ? termData.term : "-"}
                            </td>
                          );
                        })}
                      </tr>
                    ))}

                    <tr>
                      <td></td>
                      {data.map((item, index) => (
                        <td key={index} className="text-center">
                          {IsinCart(item.id) ? (
                            <button
                              onClick={() => navigate("/cart")}
                              className="btn_1 go_to_cart_btn"
                            >
                              Go to Cart
                            </button>
                          ) : (
                            <button
                              className="btn_1"
                              onClick={() => handleAddToCart(item)}
                              disabled={loadingItems[item.id]}
                            >
                              {loadingItems[item.id] ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                "Add to Cart"
                              )}
                            </button>
                          )}
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </section>
      ) : (
        <section className="pt-40 pb-40 page_notfound">
          <div className="container">
            <div className="row" style={{ justifyContent: "center" }}>
              <div className="col-lg-6 col-md-8 col-sm-12">
                <div className="inner-box">
                  <img
                    src={Nocompareimage}
                    style={{ width: "35%" }}
                    alt="img"
                  />
                  <h4 style={{ color: "#374706" }} className="mt-5">
                    No Comparing Products{" "}
                  </h4>
                  <p>Select two or three products to compare</p>
                  <div className="btn_box">
                    <Link to="/"> Go to home page</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default Compare;
